// extracted by mini-css-extract-plugin
export default {"promoCodesTable":"jS44EGeiQm3xUl4zveuQ","withSubscriptionType":"HdEUZZZToWz9Nlxfzcrk","staticOnScroll":"UUb61VUSV57OOlv1XS95"};